import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useRole } from 'app/domains/users/hooks/useRole';
import { SSORestricted } from 'shared/domains/users/components/SSORestricted';
import { InviteUserModal } from '../InviteUserModal';
export function InviteUserButton(props) {
    const { onInviteCreated } = props;
    const [displayDialog, setDisplayDialog] = useState(false);
    const role = useRole();
    if (!role.can('invite:user')) {
        return null;
    }
    return (<SSORestricted>
      <Button type="button" size="xs" onClick={() => setDisplayDialog(true)} appearance="secondary">
        <Falcon icon="user-plus"/>
        <Trans comment="Users & teams page header action - invite user">Invite user</Trans>
      </Button>
      {displayDialog && <InviteUserModal onInviteCreated={onInviteCreated} onClose={() => setDisplayDialog(false)}/>}
    </SSORestricted>);
}
